###
# Handlebars-helper для формирования цены
###
Ember.Handlebars.registerBoundHelper 'currency', (value, options) ->
  env = @container.lookup('service:environment')

  currencyOpts = {}
  if options.hash.order
    if options.hash.order.get('currency')
      currencyOpts = options.hash.order.get('currency')
    else
      currencyOpts = options.hash.order.get('organization.currency')
  else if options.hash.organization
    currencyOpts = options.hash.organization.get('currency')
  else
    session = @container.lookup('service:session')
    currencyOpts = session.get('currentOrganization.currency')

  result = env.translate_currency(value, currencyOpts)
  new Ember.Handlebars.SafeString(result)
